import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function ProtectedRoute({
  children,
  requireAdmin = false,
  requireEmployee = false,
  adminRedirect = '/admin',
}) {
  const { isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  // The employee's own self-service screens — "My leaves", "My day". An admin has
  // no leave balance and no attendance of their own, so these render a hollow
  // self-view for them; send them to the admin equivalent instead.
  if (requireEmployee && isAdmin) {
    return <Navigate to={adminRedirect} replace />;
  }
  return children || <Outlet />;
}
